import React, {
  useMemo,
  useState,
  ChangeEvent,
  MouseEvent,
  useEffect,
} from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
  InputBase,
  IconButton,
  Toolbar,
  Tooltip,
  TablePagination,
  Tabs,
  Tab,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import BookOnlineIcon from "@mui/icons-material/BookOnline";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import { visuallyHidden } from "@mui/utils";
import * as XLSX from "xlsx";
import { JoinInnerOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getLeadReportsAction } from "../../../store/reducers/dashboardSlice";
import dayjs from "dayjs";
import LeadReportList from "./Reports/LeadReportList";
import FinanceReportList from "./Reports/FinanceReportList";
import BookingReportList from "./Reports/BookingReportList";
import JobReportList from "./Reports/JobReportList";
import FeedbackReportList from "./Reports/FeedbackReportList";
import ReferrerReportList from "./Reports/ReferrerReportList";
import StatusReportList from "./Reports/StatusReportList";

interface DataRow {
  desk: string;
  commodity: string;
  name: string;
  email: string;
  quantity: number;
}

type TabKey =
  | "lead"
  | "booking"
  | "financial"
  | "job"
  | "feedback"
  | "referrer"
  | "status";

const tabData: Record<TabKey, DataRow[]> = {
  lead: [],
  booking: [],
  financial: [],
  job: [],
  feedback: [],
  referrer: [],
  status: [],
};

const CustomTable: React.FC = () => {
  const { leadReports } = useSelector((state: any) => state.dashboard);
    const { userProfile } = useSelector((state: any) => state?.user);

  const dispatch = useDispatch();

  const [tabValue, setTabValue] = useState<TabKey>("lead");

  const [filterFormData, setFilterFormData] = useState<any>({
    startDate: dayjs().subtract(30, "day").format("YYYY-MM-DD"),
    endDate: dayjs().format("YYYY-MM-DD"),
  });

  useEffect(() => {
    dispatch(getLeadReportsAction(filterFormData));
  }, []);

  return (
    <Paper
      sx={{
        width: "100%",
        overflow: "hidden",
        // bgcolor: "#f9f9f9",
        color: "#000",
        borderRadius: 2,
        // boxShadow: 3,
      }}
    >
      <Tabs
        value={tabValue}
        onChange={(e, newValue: TabKey) => setTabValue(newValue)}
        textColor="primary"
        indicatorColor="primary"
        variant="fullWidth"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab
          icon={<AssignmentIndIcon />}
          iconPosition="start"
          label="Lead Conversion Rate"
          value="lead"
        />
        <Tab
          icon={<MonetizationOnIcon />}
          iconPosition="start"
          label="Financial Summary"
          value="financial"
        />
        {/* <Tab
          icon={<BookOnlineIcon />}
          iconPosition="start"
          label="Booking"
          value="booking"
        /> */}
        <Tab
          icon={<JoinInnerOutlined />}
          iconPosition="start"
          label="Job Summary"
          value="job"
        />
        <Tab
          icon={<BookOnlineIcon />}
          iconPosition="start"
          label="Customer Feedback"
          value="feedback"
        />
        <Tab
          icon={<BookOnlineIcon />}
          iconPosition="start"
          label="Referrer Summary"
          value="referrer"
        />
        {/* <Tab
          icon={<BookOnlineIcon />}
          iconPosition="start"
          label="Status Wise Lead Summary"
          value="status"
        /> */}
      </Tabs>
      {tabValue === "lead" && <LeadReportList />}
      {tabValue === "financial" && <FinanceReportList />}
      {tabValue === "booking" && <BookingReportList />}
      {tabValue === "job" && <JobReportList userProfile={userProfile} />}
      {tabValue === "feedback" && <FeedbackReportList />}
      {tabValue === "referrer" && <ReferrerReportList userProfile={userProfile} />}
      {tabValue === "status" && <StatusReportList />}
    </Paper>
  );
};

export default CustomTable;
